import { render, staticRenderFns } from "./AICartoon_Comment.vue?vue&type=template&id=abf5a156&scoped=true"
import script from "./AICartoon_Comment.vue?vue&type=script&lang=js"
export * from "./AICartoon_Comment.vue?vue&type=script&lang=js"
import style0 from "./AICartoon_Comment.vue?vue&type=style&index=0&id=abf5a156&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abf5a156",
  null
  
)

export default component.exports